import { Outlet } from "react-router-dom";

const MarcaUnidad = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default MarcaUnidad;
